export const FETCH_CITY_AIRPORT_DICTIONARIES =
  "FETCH_CITY_AIRPORT_DICTIONARIES";
export const PARSE_PNR_DETAIL = "PARSE_PNR_DETAIL";
